import { memo } from "react";
import { Col, Row } from "reactstrap";
import { UserLink } from "../../../../components/Common/index";
import { TUser } from "../../../../common/types/user";

interface Props {
    user: TUser;
    isAdmin?: boolean;
    isDealer?: boolean;
}

const OperatorItem = ({ user, isAdmin = false, isDealer = false }: Props) => (
    <Row>
        <Col>
            <UserLink
                className="total-count-descr text-primary"
                user={user}
                isAdmin={isAdmin}
                isDealer={isDealer}
            />
        </Col>
    </Row>
);

export default memo(OperatorItem);
